import { produce } from "immer";
import React, { useContext } from "react";
import styled from "styled-components";

import { Form, TextInput } from "@examspark/common-ui";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";

import SubjectSelectInput from "../../classrooms/new-classroom/SubjectSelectInput";
import { ExamEditorContext } from "../../exam-editor/examEditor";
import { GradeLevelSelect } from "../../form/GradeLevelSelect";
import { LanguageSelect } from "../../form/LanguageSelect";
import { MaturitySelect } from "../../form/MaturitySelect";

import { ActivityEditorConfigContext } from "./ActivityEditor";

const StyledForm = styled.div`
  max-width: 40rem;
  margin: 0 auto;
  padding: 3rem;
`;

export const ActivityEditorTitleField = () => {
  const [state, dispatch] = useContext(ExamEditorContext);
  return (
    <Form.Field label="Title">
      <TextInput
        value={state.name}
        onChange={(e) => {
          dispatch({
            type: "UPDATE",
            data: produce(state, (draft) => {
              draft.name = e.target.value;
            }),
          });
        }}
      />
    </Form.Field>
  );
};

export const ActivityEditorDescriptionField = () => {
  const [state, dispatch] = useContext(ExamEditorContext);
  return (
    <Form.Field label="Description">
      <TextInput
        value={state.description}
        onChange={(e) => {
          dispatch({
            type: "UPDATE",
            data: produce(state, (draft) => {
              draft.description = e.target.value;
            }),
          });
        }}
      />
    </Form.Field>
  );
};

export const ActivityEditorSubjectField = () => {
  const [state, dispatch] = useContext(ExamEditorContext);

  return (
    <Form.Field label="Subject">
      <SubjectSelectInput
        value={state.subject}
        onChange={(value) => {
          dispatch({
            type: "UPDATE",
            data: produce(state, (draft) => {
              draft.subject = value?.value;
            }),
          });
        }}
      />
    </Form.Field>
  );
};

const ActivityEditorBasic = () => {
  const [state, dispatch] = useContext(ExamEditorContext);
  const config = useContext(ActivityEditorConfigContext);

  return (
    <PaddedBody data-cy="activity-editor-tab-basic">
      <StyledForm>
        <Form.FieldList>
          {config?.activitySettings?.fields?.title?.show && (
            <ActivityEditorTitleField />
          )}
          {config?.activitySettings?.fields?.subject?.show && (
            <>
              <ActivityEditorSubjectField />
            </>
          )}
          {config?.activitySettings?.fields?.grade?.show && (
            <Form.Field label="Grade Level">
              <GradeLevelSelect
                value={state.grade}
                onChange={(value) => {
                  dispatch({
                    type: "UPDATE",
                    data: produce(state, (draft) => {
                      draft.grade = value ?? undefined;
                    }),
                  });
                }}
              />
            </Form.Field>
          )}
          {config?.activitySettings?.fields?.maturity?.show && (
            <Form.Field label="Maturity">
              <MaturitySelect
                value={state.maturity}
                onChange={(value) => {
                  dispatch({
                    type: "UPDATE",
                    data: produce(state, (draft) => {
                      draft.maturity = value ?? undefined;
                    }),
                  });
                }}
              />
            </Form.Field>
          )}
          {config?.activitySettings?.fields?.language?.show && (
            <Form.Field label="Language">
              <LanguageSelect
                value={state.language}
                onChange={(e) => {
                  dispatch({
                    type: "UPDATE",
                    data: produce(state, (draft) => {
                      draft.language = e.target.value ?? undefined;
                    }),
                  });
                }}
              />
            </Form.Field>
          )}
        </Form.FieldList>
      </StyledForm>
    </PaddedBody>
  );
};

export default ActivityEditorBasic;
